export default [
  { value: 'open', label: 'Offen', class: 'select-default' },
  { value: 'waiting', label: 'Wartet auf Freigabe', class: 'select-info' },
  { value: 'ordered', label: 'Bestellt', class: 'select-primary' },
  { value: 'problem', label: 'Problem', class: 'select-warning' },
  { value: 'incomplete', label: 'Unvollständig geliefert', class: 'select-warning' },
  { value: 'finished', label: 'Abgeschlossen', class: 'select-success' },
  { value: 'storno', label: 'Storniert', class: 'select-danger' }
]
